import Api from './Api';

class AnalyticsApi extends Api {
  constructor(baseUrl: string, headers: any) {
    super(baseUrl, '/Analytics', headers);
  }

  getAll = (botId: string, startDate : string, endDate : string) => this.instance.get(`/${botId}?startDate=${startDate}&endDate=${endDate}`);

  getCallEvents = (botId: string, callId: string) => this.instance.get(`/${botId}/${callId}/Events`);

  get = (botId: string, startDate : string, endDate : string, event: string) => this.instance.get(`/${botId}/Events/${event}?startDate=${startDate}&endDate=${endDate}`);
  
}

export default AnalyticsApi;

